/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
import React, { useState } from 'react';

export function Calculator({
    attributes, operators, formulaUpdated, setFormulaUpdated, params, setFetchedFormula, fetchedFormula, setChangesMade,
}) {
    const [expression, setExpression] = useState(fetchedFormula[params].split(' '));
    const [numberInput, setNumberInput] = useState('');
    const [numberInputField, setNumberInputField] = useState(false);

    const createFormula = (value) => {
        setChangesMade(true);
        const final = [...expression];
        if (value !== 'number') {
            setNumberInputField(false);
            final.push(value);
            formulaUpdated[params] = final.join(' ');
            setFormulaUpdated(formulaUpdated);
        } else {
            setNumberInputField(true);
        }
        setExpression(final);
    };

    const handleClear = () => {
        const final = [...expression];
        final.pop();
        setExpression(final);
        formulaUpdated[params] = final.join(' ');
        setFormulaUpdated(formulaUpdated);
        setChangesMade(true);
    };
    return (
        <div>
            {' '}
            <div className="relative">
                <div className="rounded-[10px] w-full bg-[#E9E9E9] pl-[22px] pr-[40px] h-[61px]">
                    <p className="text-f4 font-normal text-[#000000] py-[22px]">
                        {expression.map((item) => (
                            ` ${attributes[item] || operators[item] || item} `
                        ))}
                    </p>
                </div>
                <button
                    type="button"
                    className="border border-[#555259] h-[48px] w-[48px] rounded-lg absolute top-[50%] translate-y-[-50%] right-2"
                    onClick={() => handleClear()}
                >
                    <span>
                        <img src="/images/chevrons-left.svg" alt="btn-icon" className="mx-auto" />
                    </span>
                </button>
            </div>
            <div className="flex justify-between items-start pt-5">
                <div className="w-[60%]">
                    <div className="flex items-center flex-wrap -mx-1">
                        {Object.entries(attributes).map(([key, value]) => (
                            <div className="px-1 w-fit mb-2">
                                <button onClick={() => createFormula(key)} className="px-4 py-3 border border-[#555259] bg-[#ffffff] text-f5 font-normal text-[#555259] rounded-lg hover:bg-[#555259] hover:text-[#ffffff] focus:bg-[#555259] focus:text-[#ffffff] hover:duration-150">
                                    {value}
                                </button>
                            </div>
                        ))}
                        {numberInputField === true && (
                            <div className={`px-1 ${numberInputField === true ? 'show' : 'hidden'} w-fit mb-2 numberEnter relative`}>
                                <input
                                    type="text"
                                    className="px-4 py-3 border border-[#555259] bg-[#ffffff] text-f5 font-normal text-[#555259] rounded-lg placeholder:text-f5 placeholder:font-normal placeholder:text-[#A5A5A5] w-[128px] outline-0 enterNumberField-formula"
                                    placeholder="Enter Number"
                                    onChange={(e) => setNumberInput(e.target.value)}
                                />
                                <button className="px-1 absolute top-[50%] translate-y-[-50%] right-2 enter-btn-formula" onClick={() => createFormula(numberInput)}>
                                    <img src="/images/rightopen-icon.svg" alt="Enter-icon" />
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="lg:w-[35%] xl:w-[30%] 2xl:w-[25%]">
                    <div className="flex flex-wrap -mx-1 justify-end">
                        {Object.entries(operators).map(([key, value]) => (
                            <div className="px-1 w-fit mb-2">
                                <button onClick={() => createFormula(value)} className="w-[48px] h-[40px] border border-[#555259] bg-[#ffffff] text-f6 font-semibold text-[#000000] rounded-lg hover:bg-[#555259] hover:text-[#ffffff] hover:duration-150">
                                    <p>
                                        {value}
                                    </p>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    );
}
